// icons
import { MdLibraryBooks, MdPerson, MdStraighten, MdMoneyOff, MdAccountBalance, MdLocalShipping } from "react-icons/md";

const catalogos = {
  id: 'catalogos-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'catalogos',
      title: "Catálogos",
      type: 'collapse',
      icon: MdLibraryBooks,
      children: [
        {
          id: 'usuarios',
          title: "Usuarios",
          type: 'item',
          breadcrumbs: false,
          icon: MdPerson,
          url: '/catalogos/usuarios',
          roles: [1, 100],
        },
        {
          id: 'unidades',
          title: 'Unidades',
          type: 'item',
          breadcrumbs: false,
          icon: MdStraighten,
          url: '/catalogos/unidades'
        },
        {
          id: 'conceptos-gastos',
          title: 'Conceptos gastos',
          type: 'item',
          breadcrumbs: false,
          icon: MdMoneyOff,
          url: '/catalogos/conceptos-gastos'
        },
        {
          id: 'cuentas-contables',
          title: 'Cuentas contables',
          type: 'item',
          breadcrumbs: false,
          icon: MdAccountBalance,
          url: '/catalogos/cuentas-contables',
          roles: [1, 100, 110]
        },
        {
          id: 'proveedores',
          title: 'Proveedores',
          type: 'item',
          breadcrumbs: false,
          icon: MdLocalShipping,
          url: '/catalogos/proveedores',
          roles: [1, 100, 110]
        }
      ]
    }
  ]
};

export default catalogos;
